import { render, staticRenderFns } from "./channelseahourse.vue?vue&type=template&id=3e391cbe&"
import script from "./channelseahourse.vue?vue&type=script&lang=js&"
export * from "./channelseahourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports